import Vue from 'vue'
import { fixSource } from '@/utils/request_helper'

export default {
  setGameName(state, name) {
    state.gameName = name
  },
  setSource(state, source) {
    const { source: newSource } = fixSource({ source })
    state.source = newSource
  },
  setPwaStatus(state, val) {
    state.isPwa = val
  },
  setIsTurbo(state, val) {
    state.isTurbo = val
  },
  setCurrency(state, val) {
    state.currency = val
  },
  setUserInfo(state, val) {
    state.userInfo = val
  },
  setUserEmail(state, val) {
    state.userInfo = {
      ...state.userInfo,
      email: val,
    }
  },
  setSelectedSkuInfo(state, val) {
    state.selectedSkuInfo = val
  },
  setSelectedPaymentInfo(state, val) {
    state.selectedPaymentInfo = val
  },
  setCreateOrderState(state, val) {
    state.createOrderState = val
  },
  setIkUserRoleInfos(state, val) {
    state.ikRoleInfos = val
  },
  changeStore(state, params = {}) {
    Object.assign(state, params)
  },
  setGameUid(state, uid) {
    state.gameUid = uid
  },
  setGameZoneId(state, zoneid) {
    state.gameZoneId = zoneid
  },
  setPaymentAccountInfo(state, val = {}) {
    state.paymentAccountInfo = val
  },
  setPaymentPassword(state, val = '') {
    state.paymentPassword = val
  },
  setOpenCookies(state, val) {
    state.openCookies = val
  },
  setCookieAction(state, val) {
    state.cookieActions = val
  },
  setCashierBasicInfo(state, val) {
    state.cashierBasicInfo = val
  },
  setCuntryCookie(state, val) {
    state.isCuntryCookie = val
  },
  setShareInfos(state, val) {
    state.shareInfos = val
  },
  setShareInfosReportFinished(state, val) {
    state.shareReportStatus = val
  },
  setFissionGameName(state, val) {
    state.fissionGame = val
  },
  setFissionInfos(state, val) {
    state.fissionInfos = val
  },
  setCouponDisplayStatus(state, val) {
    state.couponDisplayStatus = val
  },
  setFissionGuestInfos(state, val) {
    state.fissionGuestInfos = val
  },
  setLuckyDrawInfo(state, val) {
    state.luckyDrawData = val
  },
  setMembersUserInfo(state, val) {
    state.members.userInfo = val
  },
  setMembersUserConfig(state, val) {
    state.members.userConfig = val
  },
  setMembersLayerData(state, val) {
    state.members.layerData = val
  },
  setMembersCouponList(state, val) {
    state.members.couponList = val
  },
  setMembersCardSwipe(state, val) {
    state.members.cardSwipes = val
  },
  setMembersModalBoxList(state, val) {
    state.members.modalBoxs.list = val
  },
  setMembersModalBoxOrder(state, val) {
    state.members.modalBoxs.order = val
  },
  setLayerWeightList(state, val) {
    state.layerWeights.allList = val
  },
  setLayerWeightActiveList(state, val) {
    state.layerWeights.actives = val
  },
  setCustomGamesSkuOriginalList(state, val) {
    state.customGames.skuOriginalList = val
  },
  setCustomGamesActiveSku(state, val) {
    state.customGames.activeSku = val
  },
  setCustomGamesRoleId(state, val) {
    state.customGames.roleId = val
  },
  setCustomGamesUid(state, val) {
    state.customGames.uid = val
  },
  setCustomGamesServeId(state, val) {
    state.customGames.cpServerId = val
  },
  setLoginInfo(state, val) {
    // 登录状态：【status: 0: 登录失败，1登录成功】 【exe: 0未执行登录/登录失败 1：已执行登录】
    Vue.nextTick(() => {
      state.loginInfo = val
    })
  },
  setShowReqLoading(state, val) {
    state.showReqLoading = val
  },
  setMyTaxRate(state, val) {
    state.myTaxRate = val
  },
  setIAPStatus(state, val) {
    state.isIAP = val
  },
  setRankingActivityInfos(state, val) {
    state.rankingActivityInfo = val
  },
  setShareTitle(state, val) {
    state.shareTitle = val
  },
  setFissionFirstStatus(state, val) {
    state.fissionFirstShareStatus = val
  },
  setWatchCouponState(state, val) {
    state.watchCouponState = val
  },
  // setSearchSkuList(state, val) {
  //   state.searchSkuList = val
  // },
  setLayoutVersion(state, val) {
    state.layoutVersion = val
  },
  setInPubgmAPPState(state, val) {
    state.isInPubgmGameApp = val
  },
  setShowLandscapeGuide(state, val) {
    state.showLandscapeGuide = val
  },
  setHomeGameList(state, val) {
    state.homeGameList = val
  },
  setLoginFromCouponPop(state, val) {
    state.loginFromCouponPop = val
  },
  setABtestcode(state, val) {
    state.ABtestCode = val
  },
  setCountdownStatus(state, val) {
    state.countdownStatus = val
  },
}
